import React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';

import { BREAK_POINTS } from '../../constants';

const Wrapper = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

const ProfileCarouselSection = styled.section`
  width: 100%;
  height: 180px;
`;

const ProfileGridSection = styled.section`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

function ArtistPresenter({ artist, navigateToProfile }) {

  return (
    <Wrapper>
      <ProfileCarousel artist={artist} navigateToProfile={navigateToProfile} />
      <ProfileGrid artist={artist} navigateToProfile={navigateToProfile} />
    </Wrapper>
  );
};

const CarouselWrapper = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: 20px 0;
  
  .slick-slide {
    text-align: center;
  }
`;

const ProfileCarousel = ({ artist, navigateToProfile }) => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 10,
    slidesToScroll: 1,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
        }
      }
    ]
  };
  
  return (
    <ProfileCarouselSection>
      <CarouselWrapper>
        <Slider {...settings}>
          {artist.map((item, index) => (
            <ProfileCarouselItem key={index} item={item} navigateToProfile={() => navigateToProfile(item.id)} />
          ))}
        </Slider>
      </CarouselWrapper>
    </ProfileCarouselSection>
  );
};

const ProfileCarouselItemWrapper = styled.div`
  cursor: pointer;
`;

const ProfileImage = styled.div`
  width: 80px;
  height: 80px;
  margin: 0 auto;
  border-radius: 50%;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const ProfileName = styled.p`
  margin-top: 20px;
  font-size: 16px;
  text-align: center;
  color: #505050;
`;

const ProfileCarouselItem = ({ item, navigateToProfile }) => {

  return (
    <ProfileCarouselItemWrapper onClick={() => navigateToProfile(item.id)}>
      <ProfileImage>
        <img src={item.circle} alt={item.name} />
      </ProfileImage>
      <ProfileName>{item.name}</ProfileName>
    </ProfileCarouselItemWrapper>
  );
};

const ProfileGrid = ({ artist, navigateToProfile }) => {

  return (
    <ProfileGridSection>
      {artist.map((item, index) => (
        <ProfileGridItem key={index} item={item} navigateToProfile={navigateToProfile} />
      ))}
    </ProfileGridSection>
  );
};

const ProfileGridItemWrapper = styled.div`
  position: relative;
  width: 100%;
  cursor: pointer;

  &::before {
    content: '';
    display: block;
    padding-bottom: 135.5%;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    
  }

  /* hover 효과 추가 (선택사항) */
  &:hover img {
    
  }
`;

const ProfileGridItem = ({ item, navigateToProfile }) => {
  return (
    <ProfileGridItemWrapper onClick={() => navigateToProfile(item.id)}>
      <img src={item.img} alt={item.name} />
    </ProfileGridItemWrapper>
  );
};

export default ArtistPresenter;
